import Vue from 'vue'
import App from './App.vue'

// Vuesax Component Framework
import Vuesax from 'vuesax'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css'; // Vuesax
Vue.use(Vuesax)


// axios
import axios from "./axios.js"
//axios.defaults.baseURL = 'https://ecrm.beegbit.com/';

//axios.defaults.baseURL = 'https://crm.allpaysoft.io/';
//axios.defaults.baseURL = 'https://crm.allsolidpay.io/';

axios.defaults.baseURL = 'https://crm.e-planet.io/';
//axios.defaults.baseURL = 'https://crm.saturnpay.io/';
//axios.defaults.baseURL = 'https://crm.exotic-tech.com/';
//axios.defaults.baseURL = 'https://crm.coin-storm.com/';
//axios.defaults.baseURL = 'https://crm.cyebox.com/';
//axios.defaults.baseURL = 'https://crm.beegbit.com/';
//axios.defaults.baseURL = 'https://crm.cenex.co/';
//axios.defaults.baseURL = 'https://crm.bitbycrypto.com/';
axios.defaults.withCredentials = true;
Vue.prototype.$http = axios
 
 
// Theme Configurations
import '../themeConfig.js'


// ACL
import acl from './acl/acl'


// Globally Registered Components
import './globalComponents.js'


// i18n
import i18n from './i18n/i18n'

// Styles: SCSS
import './assets/scss/main.scss'


// Tailwind
import '@/assets/css/main.css'


// Vue Router
import router from './router'

// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from 'vue2-hammer'
Vue.use(VueHammer)


// Vuex Store
import store from './store/store'

// Clipboard
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard);

// VeeValidate
import VeeValidate from 'vee-validate';
Vue.use(VeeValidate);

import vClickOutside from 'v-click-outside';
Vue.use(vClickOutside);

// PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'


// Feather font icon
require('./assets/css/iconfont.css')


// Vue select css
// Note: In latest version you have to add it separately
// import 'vue-select/dist/vue-select.css';

Vue.config.productionTip = false

new Vue({
    router,
    store,
    acl,
    i18n,
    render: h => h(App)
}).$mount('#app')
